import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import ModalContainer from '@components/modals/ModalContainer';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { createSetOrder, updateSetOrder } from '@services/collectionService';

import { printApiError } from '@/utils/Util';

const CreateSetOrder = ({
	requestType = 'CREATE',
	setOrderType = 'SET',
	onClose,
	productIds = [],
	updateProductCard,
	selectedProduct,
	onSubmitSuccess,
	entityId,
	entityType
}) => {
	const [errors, setErrors] = useState({});
	const [name, setName] = useState('');
	const dispatch = useDispatch();

	useEffect(() => {
		setName(selectedProduct?.name || '');
	}, [selectedProduct]);

	const createSetOrPack = async () => {
		try {
			dispatch(openLoader());
			const type = setOrderType === 'SET' ? 'create-set' : 'create-pack';
			let params = `?entityId=${entityId}&entityType=${entityType}&name=${encodeURIComponent(name)}`;
			if (type === 'create-set') {
				params += `&productIds=${productIds.join(',')}`;
			}
			if (type === 'create-pack') {
				params += `&productId=${productIds[0]}`;
			}
			const data = await createSetOrder(type, params);
			updateProductCard(data, setOrderType, { type: 'CREATE_SET_OR_PACK' });
			if (onSubmitSuccess) await onSubmitSuccess();
			dispatch(closeLoader());
			onClose();
		} catch (error) {
			printApiError(error);
			dispatch(closeLoader());
		}
	};

	const updateSet = async () => {
		try {
			dispatch(openLoader());
			const type = setOrderType === 'SET' ? 'set' : 'pack';
			let params = `?name=${encodeURIComponent(name)}`;
			const data = await updateSetOrder(type, selectedProduct.id, params);
			updateProductCard(data, setOrderType, { type: 'UPDATE_SET_OR_PACK' });
			dispatch(closeLoader());
			onClose();
		} catch (error) {
			printApiError(error);
			dispatch(closeLoader());
		}
	};

	const handleSubmit = async () => {
		if (name === '') {
			setErrors({
				name: 'Name is required!'
			});
		} else {
			setErrors({});
			if (requestType === 'CREATE') await createSetOrPack();
			if (requestType === 'UPDATE') await updateSet();
		}
	};

	return (
		<ModalContainer onCloseModal={onClose} dialogClassName="create-set-pack-modal">
			<div className="common-popup shadow-24dp">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">
							{requestType === 'CREATE' ? 'Create new ' : 'Edit '}
							{setOrderType === 'SET' ? 'Set' : 'Pack'}
						</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="form-group mb-0">
						<label htmlFor="targer-styles">{setOrderType === 'SET' ? 'Set' : 'Pack'} name</label>
						<input
							type="text"
							autoComplete="off"
							id="targer-styles"
							placeholder=""
							value={name}
							autoFocus={true}
							onChange={(e) => setName(e.target.value)}
						/>
						{errors?.name && <span className="error">Name is required!</span>}
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={handleSubmit}>
							{requestType === 'CREATE' ? 'Create' : 'Update'}
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default CreateSetOrder;
